import { CustomInput } from "../facturacion/CustomInput"
import TotalCalculator from "./TotalCalculator"

function classNames(...classes) {
    return classes.filter(Boolean).join(' ') 
}

const ResumenProductos = ({full = false, productos, delProducto, updateProducto, height = null, porUnidad = true, centro=0}) => {

    return(
        <>
        <div className={full?"px-4 sm:px-6 lg:px-8 p-5 pb-2 h-full w-full" : "px-4 sm:px-6 lg:px-8 p-5 pb-2 h-full"}>
            <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                <h1 className="text-lg font-semibold text-white">3. Ingresar cantidad</h1>
                <p className="mt-2 text-sm text-grisMira">
                    {`Listado de ${centro?`servicios`:`productos`} seleccionados, `}
                    <span className="text-yellow-400 font-semibold"> ingrese cantidad</span> o 
                    <span className="text-red-500 font-semibold">{` elimine el ${centro? `servicio`: `producto`} si lo ingresó por error`}</span>
                </p>
                </div>
            </div>
            <div className="mt-5 flex flex-col p-6 pt-0 pb-5">
                <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                <div className="inline-block min-w-full align-middle">
                    <div className={`mb-4 h-full ${height}`}>
                    <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
                        <thead className="bg-secundarioMira">
                            <tr>
                                <th
                                scope="col"
                                className={classNames(centro?"hidden":"sticky", "top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8")}
                                >
                                    No.
                                </th>
                                <th
                                scope="col"
                                className={classNames(centro?"hidden":"sticky", "top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira")}
                                >
                                    Bodega
                                </th>
                                <th
                                scope="col"
                                className={classNames(centro?"hidden":"sticky","top-0 z-10 bg-secundarioMira  border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira ")}
                                >
                                    Id Producto
                                </th>
                                <th
                                scope="col"
                                className={classNames(centro?"sticky w-[1000px]":"sticky  hidden lg:table-cell", "top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira")}
                                >
                                    Descripción
                                </th>
                                {centro? null:
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    {`${centro?"Valor": "Precio"} unitario`}
                                </th>
                               }
                                {
                                    porUnidad ?
                                        <th
                                        scope="col"
                                        className={classNames(centro?"hidden":"sticky", "top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira")}
                                        >
                                            Unidad
                                        </th>
                                    : null
                                }                                
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Cantidad
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Total
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 border-b border-gray-300 py-3.5 pr-4 pl-3 bg-secundarioMira sm:pr-6 lg:pr-8"
                                >
                                <span className="sr-only">Eliminar</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-secundarioMira overflow-y-scroll">
                        {productos.map((producto, Idx) =>   
                                <tr key={Idx}>
                                    <td
                                        className={classNames(centro?"hidden":
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8'
                                        )}
                                    >
                                        {Idx + 1}
                                    </td>
                                    <td
                                        className={classNames(centro?"hidden":
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {producto.Bodega}
                                    </td>
                                    <td
                                        className={classNames(centro?"hidden":
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {producto.IdProducto}
                                    </td>
                                    <td
                                        className={classNames(centro?"flex w-600": "lg:table-cell",
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white hidden'
                                        )}
                                    >

                                        <CustomInput
                                            producto={producto}
                                            updateProducto={updateProducto}
                                            field='Descripcion'
                                            editable={producto.Editable}
                                        />
                                    </td>
                                    <>
                                        <TotalCalculator
                                            centro={centro}
                                            units={producto.Unidades}
                                            editable={producto.Editable}
                                            porUnidad={porUnidad}
                                            producto={producto}
                                            productos={productos}
                                            Idx={Idx}
                                            updateProducto={updateProducto}
                                        />
                                    </>
                                    <td
                                        className={classNames(
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'relative whitespace-nowrap py-2 pr-4 pl-3 text-right text-sm font-medium sm:pr-6 lg:pr-8'
                                        )}
                                    > 
                                        <button 
                                            type="button"
                                            onClick={() => delProducto(producto)}
                                            className="text-red-500 hover:underline"
                                        >
                                            Eliminar
                                            <span className="sr-only">, {producto.id} </span>
                                        </button>
                                    </td>
                                </tr>
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default ResumenProductos